module.exports = __webpack_public_path__ + "static/media/arrow.ac2d80bb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Support/icons/arrow.svg
// module id = 1517
// module chunks = 0